import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Planning');

export const INTERVENTIONTYPE_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.InterventionType.Name')
    .required()
    .minLength(1)
    .maxLength(100)
    .build(),
  FieldBuilder
    .text('code', 'Entity.InterventionType.Code')
    .required()
    .minLength(1)
    .maxLength(10)
    .build(),
  FieldBuilder
    .checkbox('shouldValidateInventory', 'Entity.InterventionType.ShouldValidateInventory')
    .build(),
  FieldBuilder
    .checkbox('shouldCreateNewRotation', 'Entity.InterventionType.ShouldCreateNewRotation')
    .build(),
  FieldBuilder
    .checkbox('shouldCheckStumpApplication', 'Entity.InterventionType.ShouldCheckStumpApplication')
    .build(),
  FieldBuilder
    .checkbox('shouldCheckApplyFeller', 'Entity.InterventionType.ShouldCheckApplyFeller')
    .build(),
];

export const INTERVENTIONTYPE_CONFIG = {
  entityName: 'InterventionType',
  localizationKey: 'Planning::Entity.InterventionType',
  fields: INTERVENTIONTYPE_FIELDS,
  permission: 'PlanningOperation.InterventionTypes',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Planning + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.OperationPlanning + MENU_NAME_SUFFIX,
};
